module.exports = __webpack_public_path__ + "static/img/fangzoushi.a085e97c.png";